import { Svg } from './svg'

export const GetStartedGuideIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.39392 12.0809L8 11.912L7.60608 12.0809L2 14.4835L2 2C2 1.44772 2.44772 1 3 1H13C13.5523 1 14 1.44772
      14 2V14.4835L8.39392 12.0809Z"
      stroke="#313131"
      strokeWidth="2"
    />
    <path
      d="M8 3L9.22906 5.40785L12.042 5.76393L9.98866 7.60815L10.4981 10.2361L8 8.968L5.50191 10.2361L6.01134
      7.60815L3.95801 5.76393L6.77094 5.40785L8 3Z"
      fill="#313131"
    />
  </Svg>
)
